export default "/images/vendor/@coreui/icons/svg/flag/cif-mz.svg?4bde8a7edf190b434d396100b894831d";